<app-page-breadcrumb pageTitle="Configuración Twilio"></app-page-breadcrumb>

<div class="space-y-6">

  @if (!isSuperAdmin) {
  <div class="p-4 bg-warning-50 border border-warning-200 rounded-lg dark:bg-warning-500/10 dark:border-warning-500/20">
    <p class="text-warning-700 dark:text-warning-400">
      Solo el Super Admin del business puede gestionar la configuración Twilio.
    </p>
  </div>
  }

  @if (isSuperAdmin && error) {
  <div class="p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
    <div class="flex items-center gap-3">
      <svg class="w-5 h-5 text-error-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
      <p class="text-error-600 dark:text-error-400">{{ error }}</p>
    </div>
  </div>
  }

  @if (isSuperAdmin && loading) {
  <div class="flex justify-center items-center py-16">
    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div>
    <span class="ml-3 text-gray-500 dark:text-gray-400">Cargando configuración...</span>
  </div>
  }

  <!-- FORM -->
  @if (isSuperAdmin && !loading && showForm) {
  <app-component-card
    [title]="config ? 'Editar configuración Twilio' : 'Nueva configuración Twilio'"
    desc="Credenciales del proveedor de telefonía. Los secretos se cifran AES-256-GCM en el backend.">

    <form (ngSubmit)="guardar()" #twilioForm="ngForm" class="space-y-5">

      <!-- Account SID -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Account SID <span class="text-error-500">*</span>
        </label>
        <input
          type="text"
          name="accountSid"
          [(ngModel)]="formAccountSid"
          required
          placeholder="ACxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm font-mono text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
        />
      </div>

      <!-- Auth Token -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Auth Token @if (!config) { <span class="text-error-500">*</span> }
        </label>
        <input
          type="password"
          name="authToken"
          [(ngModel)]="formAuthToken"
          [placeholder]="config?.hasAuthToken ? '••••••••  (dejar vacío para mantener)' : 'Tu auth token de Twilio'"
          autocomplete="new-password"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
        />
        @if (config?.hasAuthToken) {
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Solo escribir aquí si quieres rotar el secreto.</p>
        }
      </div>

      <!-- API Key SID -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          API Key SID
        </label>
        <input
          type="text"
          name="apiKeySid"
          [(ngModel)]="formApiKeySid"
          [placeholder]="config?.apiKeySidMasked ? (config?.apiKeySidMasked + '  (dejar vacío para mantener)') : 'SKxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm font-mono text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
        />
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Necesario para emitir AccessTokens del Voice SDK.</p>
      </div>

      <!-- API Key Secret -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          API Key Secret
        </label>
        <input
          type="password"
          name="apiKeySecret"
          [(ngModel)]="formApiKeySecret"
          [placeholder]="config?.hasApiKeySecret ? '••••••••  (dejar vacío para mantener)' : 'Secret del API Key'"
          autocomplete="new-password"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
        />
      </div>

      <!-- TwiML App SID -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          TwiML App SID
        </label>
        <input
          type="text"
          name="twimlAppSid"
          [(ngModel)]="formTwimlAppSid"
          [placeholder]="config?.twimlAppSidMasked ? (config?.twimlAppSidMasked + '  (dejar vacío para mantener)') : 'APxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm font-mono text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
        />
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Necesario para llamadas salientes desde el browser.</p>
      </div>

      <!-- Default From Number -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Número por defecto (outbound)
        </label>
        <select
          name="defaultFromNumberId"
          [(ngModel)]="formDefaultFromNumberId"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90">
          <option [ngValue]="null">— Sin default (usa el del agente/team) —</option>
          @for (n of phoneNumbers; track n.id) {
          <option [ngValue]="n.id">{{ n.phoneNumber }}{{ n.friendlyName ? ' — ' + n.friendlyName : '' }}</option>
          }
        </select>
        @if (phoneNumbers.length === 0) {
        <p class="mt-1 text-xs text-warning-600 dark:text-warning-400">No hay números registrados todavía. Regístralos en la sección "Números telefónicos".</p>
        }
      </div>

      <!-- Callback Base URL -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Callback Base URL <span class="text-xs text-gray-400 dark:text-gray-500">(opcional)</span>
        </label>
        <input
          type="text"
          name="callbackBaseUrl"
          [(ngModel)]="formCallbackBaseUrl"
          placeholder="https://api.acme.com"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
        />
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Override de la URL pública para los webhooks de Twilio. Si está vacío, usa el global del backend.</p>
      </div>

      <!-- No Agent Fallback -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Política sin agentes disponibles
        </label>
        <select
          name="noAgentFallback"
          [(ngModel)]="formNoAgentFallback"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90">
          @for (opt of fallbackOptions; track opt.value) {
          <option [ngValue]="opt.value">{{ opt.label }}</option>
          }
        </select>
      </div>

      <!-- Active toggle -->
      <div>
        <label class="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            name="isActive"
            [(ngModel)]="formIsActive"
            class="w-4 h-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500 dark:border-gray-600 dark:bg-gray-800"
          />
          <span class="text-sm text-gray-700 dark:text-gray-300">Configuración activa</span>
        </label>
      </div>

      <div class="flex items-center justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
        <app-button variant="outline" type="button" (btnClick)="cancelar()">Cancelar</app-button>
        <app-button variant="primary" type="submit" [disabled]="saving">
          {{ saving ? 'Guardando...' : (config ? 'Actualizar' : 'Guardar configuración') }}
        </app-button>
      </div>
    </form>
  </app-component-card>
  }

  <!-- VIEW CARD -->
  @if (isSuperAdmin && !loading && !showForm) {
    @if (config) {
    <app-component-card
      title="Configuración Twilio"
      desc="Credenciales actuales del business. Los secretos no se muestran nunca, solo los flags de presencia.">

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">Proveedor</p>
          <p class="text-sm font-medium text-gray-900 dark:text-white/90">{{ providerLabel(config.provider) }}</p>
        </div>
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">Account SID</p>
          <p class="text-sm font-mono text-gray-900 dark:text-white/90 break-all">{{ config.accountSid }}</p>
        </div>
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">API Key SID</p>
          <p class="text-sm font-mono text-gray-900 dark:text-white/90">{{ config.apiKeySidMasked || '—' }}</p>
        </div>
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">TwiML App SID</p>
          <p class="text-sm font-mono text-gray-900 dark:text-white/90">{{ config.twimlAppSidMasked || '—' }}</p>
        </div>
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">Auth Token guardado</p>
          @if (config.hasAuthToken) {
          <span class="inline-flex items-center rounded-full bg-success-50 px-2.5 py-0.5 text-xs font-medium text-success-700 border border-success-200">Sí</span>
          } @else {
          <span class="inline-flex items-center rounded-full bg-error-50 px-2.5 py-0.5 text-xs font-medium text-error-700 border border-error-200">No</span>
          }
        </div>
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">API Key Secret guardado</p>
          @if (config.hasApiKeySecret) {
          <span class="inline-flex items-center rounded-full bg-success-50 px-2.5 py-0.5 text-xs font-medium text-success-700 border border-success-200">Sí</span>
          } @else {
          <span class="inline-flex items-center rounded-full bg-error-50 px-2.5 py-0.5 text-xs font-medium text-error-700 border border-error-200">No</span>
          }
        </div>
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">Número por defecto</p>
          <p class="text-sm text-gray-900 dark:text-white/90">{{ defaultNumberLabel() }}</p>
        </div>
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">Callback Base URL</p>
          <p class="text-sm text-gray-900 dark:text-white/90 break-all">{{ config.callbackBaseUrl || '—' }}</p>
        </div>
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">Política sin agentes</p>
          <p class="text-sm text-gray-900 dark:text-white/90">{{ fallbackLabel(config.noAgentFallback) }}</p>
        </div>
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">Estado</p>
          @if (config.isActive) {
          <span class="inline-flex items-center rounded-full bg-success-50 px-2.5 py-0.5 text-xs font-medium text-success-700 border border-success-200">Activa</span>
          } @else {
          <span class="inline-flex items-center rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-700 border border-gray-200">Inactiva</span>
          }
        </div>
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">Última verificación</p>
          <p class="text-sm text-gray-900 dark:text-white/90">{{ config.lastVerifiedAt || 'Nunca verificada' }}</p>
        </div>
      </div>

      <div class="flex flex-wrap items-center justify-end gap-3 pt-4 mt-4 border-t border-gray-200 dark:border-gray-700">
        <app-button variant="outline" type="button" (btnClick)="verificar()" [disabled]="verifying">
          {{ verifying ? 'Verificando...' : 'Verificar credenciales' }}
        </app-button>
        <ng-container *appHasPermission="'calls:delete'">
          <app-button variant="danger" type="button" (btnClick)="eliminar()">
            Eliminar
          </app-button>
        </ng-container>
        <ng-container *appHasPermission="'calls:edit'">
          <app-button variant="primary" type="button" (btnClick)="abrirFormulario()">
            Editar
          </app-button>
        </ng-container>
      </div>
    </app-component-card>
    } @else {
    <app-component-card
      title="Sin configuración Twilio"
      desc="Para habilitar llamadas, registra las credenciales del business en consola Twilio.">

      <div class="flex flex-col items-center justify-center py-10 text-center gap-4">
        <div class="flex h-16 w-16 items-center justify-center rounded-full bg-brand-50 dark:bg-brand-500/10">
          <svg class="h-8 w-8 text-brand-600 dark:text-brand-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
          </svg>
        </div>
        <div>
          <p class="text-sm text-gray-600 dark:text-gray-400">Aún no hay configuración Twilio para este business.</p>
          <p class="text-xs text-gray-500 dark:text-gray-500 mt-1">Necesitas el Account SID, Auth Token y, opcionalmente, las API Keys y el TwiML App SID para el dialer del agente.</p>
        </div>
        <ng-container *appHasPermission="'calls:create'">
          <app-button variant="primary" type="button" (btnClick)="abrirFormulario()">
            Configurar Twilio
          </app-button>
        </ng-container>
      </div>
    </app-component-card>
    }
  }
</div>
